import { render, staticRenderFns } from "./RestartButton.vue?vue&type=template&id=944592f8"
import script from "./RestartButton.vue?vue&type=script&lang=js"
export * from "./RestartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports